export default function ai(builder) {
  return {
    getThreadMessages: builder.query({
      query: (threadId) => `/ai/threads/${threadId}/messages`,
    }),
  };
}
